// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"a40bdf93","453":"c128e00c","732":"403884a2","879":"6e6850c8","977":"a684d55b"}[chunkId] + ".chunk.js";
};